import DataChip from './DataChip';
export default DataChip;
